/* ═══════════════════════════════════════
   SWF Desktop Mega Nav — countdown + menu state
   ═══════════════════════════════════════ */

class SwfDesktopNav extends HTMLElement {
  connectedCallback() {
    this.startCountdown();
    this.bindMega();
    this.bindScrollAnchors();
  }

  bindScrollAnchors() {
    this.querySelectorAll('[data-swf-scroll-anchor]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const url = new URL(link.href, window.location.href);
        if (url.pathname !== '/' && url.pathname !== window.location.pathname) return;
        const target = document.querySelector(url.hash);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', url.hash);
      });
    });
  }

  startCountdown() {
    const target = this.dataset.targetDate;
    if (!target) return;
    const targetDate = new Date(target).getTime();
    if (Number.isNaN(targetDate)) return;

    const dEl = this.querySelector('[data-countdown-d]');
    const hEl = this.querySelector('[data-countdown-h]');
    const mEl = this.querySelector('[data-countdown-m]');
    if (!dEl || !hEl || !mEl) return;

    const tick = () => {
      const now = Date.now();
      let diff = Math.max(0, targetDate - now);
      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;
      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;
      const minutes = Math.floor(diff / 60000);

      dEl.textContent = String(days).padStart(2, '0');
      hEl.textContent = String(hours).padStart(2, '0');
      mEl.textContent = String(minutes).padStart(2, '0');

      if (targetDate - now <= 0) {
        const wrapper = this.querySelector('[data-countdown]');
        if (wrapper) {
          const label = wrapper.querySelector('.swf-desktop-nav__countdown-label');
          if (label) label.textContent = 'Festival Live';
        }
      }
    };

    tick();
    this._countdownTimer = setInterval(tick, 30000);
  }

  bindMega() {
    const triggers = this.querySelectorAll('[data-mega-trigger]');
    triggers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const item = btn.closest('.swf-desktop-nav__item--has-children');
        if (!item) return;
        const wasOpen = item.hasAttribute('data-open');
        this.closeAllMegas();
        if (!wasOpen) {
          item.setAttribute('data-open', '');
          btn.setAttribute('aria-expanded', 'true');
          this.positionFixedMega(item);
        }
      });

      btn.addEventListener('mouseenter', () => {
        const item = btn.closest('.swf-desktop-nav__item--has-children');
        if (item) this.positionFixedMega(item);
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.closeAllMegas();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeAllMegas();
    });

    window.addEventListener('resize', () => {
      const open = this.querySelector('.swf-desktop-nav__item--has-children[data-open]');
      if (open) this.positionFixedMega(open);
    });
  }

  positionFixedMega(item) {
    const panel = item.querySelector('[data-mega-panel]');
    if (!panel) return;
    const style = window.getComputedStyle(panel);
    if (style.position !== 'fixed') return;
    const navRect = this.getBoundingClientRect();
    panel.style.top = `${navRect.bottom}px`;
  }

  closeAllMegas() {
    this.querySelectorAll('.swf-desktop-nav__item[data-open]').forEach((item) => {
      item.removeAttribute('data-open');
      const btn = item.querySelector('[data-mega-trigger]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  disconnectedCallback() {
    if (this._countdownTimer) clearInterval(this._countdownTimer);
  }
}

if (!customElements.get('swf-desktop-nav')) {
  customElements.define('swf-desktop-nav', SwfDesktopNav);
}
